import io from "socket.io-client"

export * from "./user"
export * from "./drive"

export const clientSocket = io({
    path: "/socket.io",
    transports: ["polling"],
})

export const listenSocketConnectionError = (callback: () => void) => {
    clientSocket.io.on("reconnect_error", callback)
}
